<form class="form-horizontal" [formGroup]="form">

  <div class="modal-header">
    <h4 class="modal-title">
      {{articleNumberMapping ? ('editCustomArticleNumberPopup.title.edit' | translate) : ('editCustomArticleNumberPopup.title.new' | translate)}}
    </h4>
  </div>

  <div class="modal-body pt-0">
    <div class="modal-body-inner">

      <div class="mb-3 row">
        <label class="col-md-3 col-form-label" for="articleNumber">{{'editCustomArticleNumberPopup.label.article_number' | translate}}</label>
        <div class="col-md-9">
          <input
            appInputAutoFocus
            inputRestricter="^[0-9a-zA-Z-/]*$"
            (inputEvent)="form.controls.articleNumber.setValue($event)"
            type="text"
            spellcheck="false"
            id="articleNumber"
            formControlName="articleNumber"
            class="form-control"
            [attr.readonly]="articleNumberMapping"
            [class.is-invalid]="form.controls.articleNumber.touched && !form.controls.articleNumber.valid">
          <div class="invalid-feedback">
            {{'editCustomArticleNumberPopup.error.required' | translate}}
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-3 col-form-label" for="customNumber">{{'editCustomArticleNumberPopup.label.custom_number' | translate}}</label>
        <div class="col-md-9">
          <input
            inputRestricter="^[0-9a-zA-Z-/. ]*$"
            (inputEvent)="form.controls.customNumber.setValue($event)"
            type="text"
            spellcheck="false"
            id="customNumber"
            formControlName="customNumber"
            class="form-control is-invalid"
            [class.is-invalid]="form.controls.customNumber.touched && !form.controls.customNumber.valid">
          <div class="invalid-feedback">
            {{form.controls.customNumber.errors?.messageKey | translate:{'0':form.controls.customNumber.errors?.param} }}
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary btn-cancel"
      (mousedown)="clearValidationAndClose()"
      (click)="clearValidationAndClose()">
        {{'global.label.cancel' | translate}}
    </button>
    <button type="submit" class="btn btn-primary btn-forward" (click)="accept()">{{'global.label.accept' | translate}}</button>
  </div>

</form>
